<template>
  <svg viewBox="0 0 24 24" fill="none" :stroke="icon.color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
    <path v-for="(path, index) in icon.paths" :key="index" :d="path" />
    <text v-if="name === 'sulphites'" x="12" y="14.5" text-anchor="middle" :fill="icon.color" stroke="none" font-size="8" font-family="Arial, sans-serif" font-weight="700">SO₂</text>
  </svg>
</template>

<script>
const icons = {
  gluten: { color: '#a75120', paths: ['M6 21 18 3M10 17C5 18 3 15 3 12C7 12 10 13 10 17ZM13 13C9 12 9 8 10 6C14 7 15 10 13 13ZM16 9C15 5 17 2 20 2C22 6 20 8 16 9ZM10 17C12 12 16 12 19 13C18 17 14 19 10 17Z'] },
  milk: { color: '#16768e', paths: ['M8 2h8v4l3 4v12H5V10l3-4ZM8 6h8M5 10h14M8 14h8v4H8Z'] },
  egg: { color: '#a56c13', paths: ['M19 15C19 20 16 22 12 22S5 20 5 15C5 9 9 2 12 2S19 9 19 15ZM9 12C8 14 8 16 9 18'] },
  nuts: { color: '#a54155', paths: ['M12 2C5 6 2 12 5 18C7 23 14 23 18 18C22 12 17 5 12 2ZM12 3C8 9 7 16 11 21M13 5C16 10 17 16 13 20M11 7V17'] },
  peanuts: { color: '#865139', paths: ['M9 2C4 2 3 7 6 11C7 13 3 16 6 20C9 24 15 21 16 18C17 15 16 13 18 10C22 4 16 0 13 4C11 6 11 2 9 2ZM8 6l2 1M8 17l2 1M14 8l2 1M12 16l2 1'] },
  mustard: { color: '#9b6513', paths: ['M9 2h6v3H9ZM9 5v3l-3 4v10h12V12l-3-4V5M6 13h12M10 17h4M12 15v4'] },
  sulphites: { color: '#764a78', paths: ['M22 12A10 10 0 1 1 2 12A10 10 0 1 1 22 12Z'] },
  soy: { color: '#276f48', paths: ['M20 2C8 3 3 8 3 15C3 20 7 23 12 20C18 17 20 9 20 2ZM10 16a2 2 0 1 1-4 0a2 2 0 1 1 4 0ZM15 11a2 2 0 1 1-4 0a2 2 0 1 1 4 0ZM18 6a1.5 1.5 0 1 1-3 0a1.5 1.5 0 1 1 3 0Z'] },
  sesame: { color: '#716253', paths: ['M7 3C2 7 2 12 5 13C9 13 10 8 7 3ZM16 2C11 6 11 11 14 12C18 12 19 7 16 2ZM15 13C9 15 7 20 10 22C14 23 18 18 15 13Z'] },
  celery: { color: '#387342', paths: ['M9 22 7 9M12 22V7M15 22l3-13M7 10C1 12 1 5 5 5C4 0 11 1 11 5M12 8C8 6 9 1 13 2C16-1 20 3 16 6M17 10C13 8 17 3 20 6C25 6 22 13 17 10ZM8 22h8'] },
  crustaceans: { color: '#276896', paths: ['M19 14C19 21 5 21 5 14C5 8 19 8 19 14ZM8 10V8M16 10V8M5 13 2 10V6M19 13l3-3V6M2 6 1 2M2 6l4-3M22 6l1-4M22 6l-4-3M5 16l-3 3M7 19l-1 3M19 16l3 3M17 19l1 3'] },
  lupin: { color: '#a56c13', paths: ['M10 10C5 13 1 9 3 5C5 1 11 4 10 10ZM15 10C12 5 16 1 20 3C24 5 21 11 15 10ZM11 14C17 12 21 16 18 20C15 24 9 20 11 14ZM4 6l4 2M18 4l-1 4M13 16l4 2'] },
};
export default {
  props: { name: { type: String, required: true } },
  computed: { icon() { return icons[this.name]; } },
};
</script>



// WEBPACK FOOTER //
// src/components/MenuAllergen.vue